import OcrActivityPage from "./OcrActivityPage";

export default OcrActivityPage;